import { lazy, Suspense, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingSpinner } from '@/components/ui/loading-spinner';

const CommandPalette = lazy(() =>
  import('@/components/ui/command-menu').then((module) => ({
    default: module.CommandPalette,
  })),
);

export function CommandMenuLoader() {
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(false);
  const [open, setOpen] = useState(false);

  const openCommandMenu = useCallback(() => {
    setMounted(true);
    setOpen(true);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        openCommandMenu();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [openCommandMenu]);

  if (!mounted) return null;

  return (
    <Suspense
      fallback={
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-background/85 backdrop-blur-sm"
          role="status"
          aria-live="polite"
        >
          <div className="surface-card rounded-panel-lg px-6 py-5">
            <LoadingSpinner size="md" text={t('common.loading', 'Loading...')} />
          </div>
        </div>
      }
    >
      <CommandPalette open={open} onOpenChange={setOpen} />
    </Suspense>
  );
}
